import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Rail, RailContainer } from 'components/Rail';
import { checkForPackage } from 'components/packages/getPackage';
import MidresponsiveAd from 'components/Ad/Midresponsive';
import * as CustomPropTypes from 'lib/CustomPropTypes';

import { getFeatureConfigForBrand } from 'lib/getFeatureStatus';
import { LAYOUT_7_LEFT_COLUMNS_AT_LARGE_BREAKPOINT } from 'lib/brandFeatures.json';
import getPackagesForZone from '../getPackagesForZone';

import styles from './styles.module.scss';

function LeftRail({ packages }, context) {
  const { isFirstRail, vertical } = context;
  // eslint-disable-next-line max-len
  const has7LeftColumnsAtLargeBreakpoint = getFeatureConfigForBrand(LAYOUT_7_LEFT_COLUMNS_AT_LARGE_BREAKPOINT, vertical);

  const hasTitle = checkForPackage(packages, 'collectionTitle', 1);
  const containerClasses = classNames('layout-leftRail', { hasTitle }, 'layout-grid-container');
  const leftClasses = classNames('layout-grid-item', {
    'grid-col-5-l grid-col-4-xl': has7LeftColumnsAtLargeBreakpoint,
    'grid-col-4-l': !has7LeftColumnsAtLargeBreakpoint,
  });
  const rightClasses = classNames(styles.right, 'layout-grid-item', {
    'grid-col-7-l grid-col-8-xl': has7LeftColumnsAtLargeBreakpoint,
    'grid-col-8-l': !has7LeftColumnsAtLargeBreakpoint,
  });

  return (
    <>
      <RailContainer className={containerClasses}>
        <Rail className={leftClasses}>
          {getPackagesForZone(1, packages, { ...context, railContext: 'left' })}
        </Rail>
        <div className={rightClasses}>
          {getPackagesForZone(2, packages, { ...context, isRailAdjacent: true })}
        </div>
      </RailContainer>

      {isFirstRail && <MidresponsiveAd />}
    </>
  );
}

LeftRail.propTypes = {
  packages: PropTypes.arrayOf(CustomPropTypes.package).isRequired,
};

LeftRail.contextTypes = {
  ...CustomPropTypes.layoutContext,
};

export default LeftRail;
